import React from 'react';

import './App.css';

import Cabeca from "./header"

import ShowList from './renderList';

function App() {
  
  return(
    <div>
   
    <Cabeca />
    
    </div>
  )
}

export default App;
